import React from "react";
import HeaderNav from "../../header/header";
import {Button, Col, DatePicker, Form, Input, Layout, message, Row, Select, Space, Table} from "antd";
import "../css/SingleCreateFinancialClaim.css"
import CreateTable from "./createTable";
const { Content } = Layout;
const {Option} = Select;
let data=[
    {
        key:1,
        Message:'There are some warnings',
        Material:'GXD0T69863',
        Quantity:'13',
        EndUserName:'',
        UnitClaimVlaue:'11.1',
        ClaimValue:'144.3',
        SerialNumber:'MJ0DQYLA'
    },
    {
        key:2,
        Message:'There are some warnings',
        Material:'GXD0T69863',
        Quantity:'13',
        EndUserName:'',
        UnitClaimVlaue:'11.1',
        ClaimValue:'144.3',
        SerialNumber:'MJ0DQYLA'
    }
]

class SingleCreateFinancialClaim extends React.Component{
    formRef = React.createRef();
    constructor(props) {
        super(props);
        this.state={
            dataSource:this.props.data,
            count:this.props.data && this.props.data.length?this.props.data.length+1:0,

        }
        this.claim_category=[
            {value:'EM-Debit Memo Req',key:'YVDR'},
            {value:'EM-Credit Memo Req',key:'YVCR'},
            {value:'LI Rebate Adj- Incre',key:'YFKI'},
            {value:'LI Rebate Adj- Decre',key:'YFKD'},
            {value:'LI-Returns',key:'YBRE'},
            {value:'NoCredit return',key:'YBEX'},
            {value:'LI-Debit Memo Req',key:'YBDR'},
            {value:'EM-Debit DR Margin',key:'YBD5'},
            {value:'LI-Credit Memo Req',key:'YBCR'},
            {value:'EM-Credit DR Margin',key:'YBC5'},
        ]
        this.channel_list=[
            {value:'Distribution',key:'11'},
            {value:'Key account',key:'21'},
            {value:'Direct Sales',key:'31'},
            {value:'Key Account Indirect',key:'41'},
            {value:'SMB Direct',key:'71'},
            {value:'SMB Indirect',key:'81'},
            {value:'Broker Sales',key:'91'},
        ]
        this.currency_list=[
            {value:'Swiss Franc',key:'CHF'},
            {value:'Danish Krone',key:'DKK'},
            {value:'Euro',key:'EUR'},
            {value:'Pound sterling',key:'GBP'},
            {value:'Scheckel',key:'ILS'},
            {value:'Norwegian Krone',key:'NOK'},
            {value:'Rouble',key:'RUB'},
            {value:'Swedish Krona',key:'SEK'},
            {value:'US Dollar',key:'USD'},
            {value:'Rand',key:'ZAR'},
        ]
        this.division_list=[
            {value:'Common Division',key:'00'},
            {value:'Think/System X',key:'93'},
            {value:'Idea',key:'94'},
        ]
    }
    componentWillMount(){
        let uesrId = window.localStorage.getItem('userId')
        if(!uesrId){
            message.warn('Please log in first!')
            this.props.history.push({
                pathname: '/disputeHome'
            })
        }
    }
    handleAdd = () => {
        const { count, dataSource } = this.state;
        const newData = {
            key: count,
            Message:'There are some warnings',
            Material:'GXD0T69863',
            Quantity:'13',
            EndUserName:'',
            UnitClaimVlaue:'11.1',
            ClaimValue:'144.3',
            SerialNumber:'MJ0DQYLA'

        };
        this.setState({
            dataSource: [...dataSource, newData],
            count: count + 1,
        });
    };
    changeData = (val) =>{
        console.log(val)
    }
    onFinish = (values) =>{
        console.log('success',values)
    }
    onFinishFailed = (values) =>{
        console.log('error',values)
    }
    InvoiceData=()=>{
        let invoiceNo = this.formRef.current.getFieldValue('invoiceNo')
        if(invoiceNo){
            console.log('invoiceNo有值')
        }
        this.formRef.current.setFieldsValue({
            claimCategory:1,
            soldToNumber:123
        })
    }
    render() {
        return <div>
            <HeaderNav parmas={'/singleCreateFinancialClaim'}/>
            <Layout className="site-layout-background SingleCreateFinancialClaim" style={{ padding: '24px 0' }}>
                <Content style={{ padding: '0 24px', minHeight: 280 ,width: '1000px',margin: '0 auto'}}>
                    <h1 style={{marginLeft:'5%'}}>Create Financial Claim</h1>
                    <Form
                        name="internal"
                        labelCol={{ span:12 }}
                        wrapperCol={{ span: 11}}
                        ref={this.formRef}
                        onFinish={this.onFinish}
                        onFinishFailed={this.onFinishFailed}
                    >
                        <Row>
                            <Col span={8}>
                                <Form.Item
                                    label="Claim Category"
                                    name="claimCategory"
                                    rules={[{ required: true }]}
                                >
                                    <Select defaultValue="Please Select">
                                        {
                                            this.claim_category.map((item)=>{
                                                return <Option value={item.key} >{item.value}</Option>
                                            })
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Sold to Party"
                                    name="soldToNumber"
                                    rules={[{ required: true}]}
                                >
                                <Input />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Bill to Party"
                                    name="billToNumber"
                                    rules={[{ required: true }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Sales Org"
                                    name="salesOrg"
                                    rules={[{ required: true }]}
                                >
                                    <Select />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Pricing Date"
                                    name="pricingDate"
                                    rules={[{ required: true }]}
                                >
                                    <DatePicker style={{width:'100%'}} />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Requested Delivery Date"
                                    name="reqDeliveryDate"
                                    rules={[{ required: false }]}
                                >
                                    <DatePicker style={{width:'100%'}} />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Channel"
                                    name="channel"
                                    rules={[{ required: true }]}
                                >
                                    <Select defaultValue="Please Select">
                                        {
                                            this.channel_list.map((item)=>{
                                                return <Option value={item.key} >{item.value}</Option>
                                            })
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Currency"
                                    name="currency"
                                    rules={[{ required: true }]}
                                >
                                    <Select defaultValue="Please Select">
                                        {
                                            this.currency_list.map((item)=>{
                                                return <Option value={item.key} >{item.value}</Option>
                                            })
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Purchase Order Number"
                                    name="poNumber"
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Sales Office"
                                    name="salesOffice"
                                    rules={[{ required: true }]}
                                >
                                    <Select />
                                </Form.Item>
                            </Col>
                            <Col span={16}>
                                <Form.Item
                                    label="SBO-No/SOP Ref./LENOVO Ref"
                                    labelCol={{span:10}}
                                    name="ref"
                                    rules={[{ required: true }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Claim Type"
                                    name="claimType"
                                    rules={[{ required: true }]}
                                >
                                    <Select />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="BP-Reference"
                                    name="bpReference"
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Division"
                                    name="division"
                                    rules={[{ required: true }]}
                                >
                                    <Select defaultValue="Please Select">
                                        {
                                            this.division_list.map((item)=>{
                                                return <Option value={item.key} >{item.value}</Option>
                                            })
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Ship to Party"
                                    name="shipToNumber"
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Street/House Number"
                                    name="street"
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Street 2"
                                    name="street2"
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Country"
                                    name="country"
                                    rules={[{ required: false }]}
                                >
                                    <Select />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Postal Code"
                                    name="postalCode"
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="City"
                                    name="city"
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Cotact Person"
                                    name="contactPerson"
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Email"
                                    name="email"
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Phone Number"
                                    name="phoneNumber"
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item
                                    label="Comment"
                                    labelCol={{span:4}}
                                    name="comment"
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item
                                    label="Billing Instruction"
                                    labelCol={{span:4}}
                                    name="billingInstruction"
                                    rules={[{ required: false }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="Invoice Number"
                                    labelCol={{span:8}}
                                    wrapperCol={{ span: 24}}
                                    name="invoiceNo"
                                    rules={[{ required: false }]}
                                >
                                    <Input suffix={<Button onClick={this.InvoiceData}>Invoice Copy</Button>}/>
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="Label"
                                    labelCol={{span:8}}
                                    name="lable"
                                    rules={[{ required: false }]}
                                >
                                    <Select />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Form.Item style={{textAlign:'right'}}>
                        </Form.Item>
                        <div style={{width:"1000px",margin:'0 auto'}}>
                            <h1>Financial Claim Item</h1>
                            <CreateTable data={[]} changeData={this.changeData.bind(this)} />
                            <Button style={{position: "relative",right: "-204px",bottom: "48px"}} type="primary" htmlType="submit">
                                Submit
                            </Button>
                        </div>
                    </Form>
                </Content>
            </Layout>
        </div>
    }
}

export default SingleCreateFinancialClaim;